import React, { useState } from "react";
import { addAdmin } from "../../api/admin";
import { useHistory } from "react-router-dom";

const AddAdmin: React.FC = () => {
  const navigate = useHistory();
  const [form, setForm] = useState({
    username: "",
    password: "",
    confirmPassword: "",
  });
  const [error, setError] = useState<string | null>(null);
  const [success, setSuccess] = useState<string | null>(null);

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setForm({ ...form, [e.target.name]: e.target.value });
    setError(null);
    setSuccess(null);
  };

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    if (!form.username || !form.password || !form.confirmPassword) {
      setError("All fields are required.");
      return;
    }
    if (form.password !== form.confirmPassword) {
      setError("Passwords do not match.");
      return;
    }
    if (form.password.length < 8) {
      setError("Password must be at least 8 characters.");
      return;
    }
    try {
      const data = { username: form.username, password: form.password };
      const res = await addAdmin(data);
      if (res.message === "Admin added successfully") {
        setSuccess("Admin added successfully!");
        setForm({ username: "", password: "", confirmPassword: "" });
        setTimeout(() => navigate.push("/companies/admin"), 1200);
      } else {
        setError(res.message || "Failed to add admin. Please try again.");
      }
    } catch (error) {
      console.error("Error adding admin:", error);
      setError("Failed to add admin. Please try again.");
    }
  };

  return (
    <section
      style={{
        maxWidth: 400,
        margin: "40px auto",
        padding: 24,
        border: "1px solid #eee",
        borderRadius: 8,
        background: "#fff",
      }}
      aria-labelledby="add-admin-title">
      <h2 id="add-admin-title">Add Admin</h2>
      <form
        onSubmit={handleSubmit}
        autoComplete="off"
        aria-describedby="add-admin-desc">
        <p id="add-admin-desc" style={{ fontSize: "0.95rem", color: "#555" }}>
          Create a new admin account. Password must be at least 8 characters.
        </p>
        <div style={{ marginBottom: 16 }}>
          <label htmlFor="username">Username:</label>
          <input
            id="username"
            type="text"
            name="username"
            value={form.username}
            onChange={handleChange}
            style={{ width: "100%", padding: 8, marginTop: 4 }}
            autoComplete="off"
            required
            aria-required="true"
          />
        </div>
        <div style={{ marginBottom: 16 }}>
          <label htmlFor="password">Password:</label>
          <input
            id="password"
            type="password"
            name="password"
            value={form.password}
            onChange={handleChange}
            style={{ width: "100%", padding: 8, marginTop: 4 }}
            autoComplete="new-password"
            required
            aria-required="true"
            minLength={6}
          />
        </div>
        <div style={{ marginBottom: 16 }}>
          <label htmlFor="confirmPassword">Confirm Password:</label>
          <input
            id="confirmPassword"
            type="password"
            name="confirmPassword"
            value={form.confirmPassword}
            onChange={handleChange}
            style={{ width: "100%", padding: 8, marginTop: 4 }}
            autoComplete="new-password"
            required
            aria-required="true"
            minLength={6}
          />
        </div>
        {error && (
          <div
            role="alert"
            style={{ color: "red", marginBottom: 12 }}
            aria-live="assertive">
            {error}
          </div>
        )}
        {success && (
          <div
            role="status"
            style={{ color: "green", marginBottom: 12 }}
            aria-live="polite">
            {success}
          </div>
        )}
        <button
          type="submit"
          style={{
            padding: "8px 16px",
            background: "#1e3a8a",
            color: "#fff",
            border: "none",
            borderRadius: 4,
            cursor: "pointer",
            fontWeight: 600,
          }}>
          Add Admin
        </button>
      </form>
    </section>
  );
};

export default AddAdmin;
